"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.creditCardIsExpired = void 0;
const moment = require("moment");
const creditCardIsExpired = (creditCard) => creditCard &&
    moment(creditCard.expirationDate, "MM/YYYY")
        .endOf("month")
        .isBefore(moment());
exports.creditCardIsExpired = creditCardIsExpired;
//# sourceMappingURL=creditCardIsExpired.js.map